import { createTodoItem } from '@erikdakoda/todo/ai-tools/createTodoItem';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(createTodoItem);
